export default __webpack_public_path__ + "static/media/lawyer.995374a5.png";